import { useTimer } from "react-timer-hook"


function Timer(props) {

    const { time = 1, handleExpired, text, endText } = props


    const expiryTimestamp = new Date();
    expiryTimestamp.setMinutes(expiryTimestamp.getMinutes() + time);

    const {
        seconds,
        minutes,
        hours,
        isRunning,
    } = useTimer({
        expiryTimestamp,
        onExpire: () => {
            handleExpired()
        },
    });


    return <div>
        (
        {" " + text + " "}
        <span>{String(minutes).padStart(2, '0')}:</span>
        <span>{String(seconds).padStart(2, '0')}</span>
        {" " + endText}
        )
    </div>

}

export default Timer
